<template>
  <div
    class="content has-text-centered"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <div
      class="internalTransferStepSection"
      id="StepSection1"
    >
      <div
        class="stepSectionLabel"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar','has-text-left': Language != 'fa' && Language != 'ar'}"
      >{{$t("from").tUpper()}}</div>

      <div
        class="control"
        :class="{'disabled':IsVerified===false}"
      >
        <label class="radio">
          <input
            type="radio"
            value="yes"
            v-model="selected.fromWallet"
            name="mainOptionFrom"
          />
          <div class="labelText">{{$t("wallet").tUpper()}}</div>
        </label>
        <label class="radio is-pulled-right">
          <input
            type="radio"
            value="no"
            v-model="selected.fromWallet"
            name="mainOptionFrom"
          />
          <div class="labelText">{{$t("trading_account").tUpper()}}</div>
        </label>
      </div>
      <div
        class="control"
        :class="{'disabled':IsVerified===false}"
      >
        <input
          type="text"
          class="input"
          :value="$t('balance').tUpper() + ' '  + $formatMoney(Math.floor(User.wallet.balance*100)/100, currencySymbols[User.wallet.currency])"
          readonly
        />
        <span
          class="select is-pulled-right"
          :class="selected.fromWallet!='no'?'disabled':''"
        >
          <select v-model="selected.from.external_id">
            <option
              selected
              value
            ></option>
            <option
              v-for="ta in User.TA"
              :value="ta.external_id"
              v-if="ta.type === 'live' && ta.transfer_locked === 'no' && ta.group.indexOf('umam-Master') !== 0 && (ta.account_type !== '' || ta.platform === 'transfer')"
              :key="ta.external_id"
            >{{ta.external_id}} - {{$formatMoney(getFromAmount(ta), currencySymbols[ta.currency])}}</option>
          </select>
        </span>
      </div>
    </div>

    <span :class="{'is-pulled-right': Language == 'fa' || Language == 'ar', 'is-pulled-left' : Language != 'fa' && Language != 'ar'}">
      <img
        width="50px;"
        class="nextStepArrow"
        :class="disableSection2()"
        src="../../assets/img/arrow-down.svg"
      />
    </span>
    <div style="clear:both"></div>

    <div
      class="internalTransferStepSection"
      :class="disableSection2()"
      id="StepSection2"
    >
      <div
        class="stepSectionLabel"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar','has-text-left': Language != 'fa' && Language != 'ar'}"
      >{{$t("to").tUpper()}}</div>

      <div class="control">
        <label
          class="radio"
          :class="disableToWallet()"
        >
          <input
            type="radio"
            value="yes"
            v-model="selected.toWallet"
            name="mainOptionTo"
          />
          <div class="labelText">{{$t("wallet").tUpper()}}</div>
        </label>
        <label class="radio is-pulled-right">
          <input
            type="radio"
            value="no"
            v-model="selected.toWallet"
            name="mainOptionTo"
          />
          <div class="labelText">{{$t("trading_account").tUpper()}}</div>
        </label>
      </div>

      <div class="control">
        <input
          type="text"
          class="input"
          :value="$t('balance').tUpper() + ' '  + $formatMoney(Math.floor(User.wallet.balance*100)/100, currencySymbols[User.wallet.currency])"
          :class="disableToWallet()"
          readonly
        />
        <span class="select is-pulled-right">
          <select
            v-model="selected.to.external_id"
            :class="selected.toWallet!='no'?'disabled':''"
          >
            <option
              selected
              value
            ></option>
            <option
              v-for="ta in User.TA"
              :value="ta.external_id"
              v-if="ta.type === 'live' && ta.transfer_locked === 'no' && ta.group.indexOf('umam-Master') !== 0 && (ta.account_type !== '' || ta.platform === 'transfer')"
              :key="ta.external_id"
            >{{ta.external_id}} - {{$formatMoney(ta.balance, currencySymbols[ta.currency])}}</option>
          </select>
        </span>
      </div>
    </div>
    <span :class="{'is-pulled-right': Language == 'fa' || Language == 'ar', 'is-pulled-left' : Language != 'fa' && Language != 'ar'}">
      <img
        width="50px;"
        class="nextStepArrow"
        :class="disableSection3()"
        src="../../assets/img/arrow-down.svg"
      />
    </span>
    <div style="clear:both"></div>

    <div
      class="internalTransferStepSection"
      :class="disableSection3()"
      id="StepSection3"
    >
      <div
        class="stepSectionLabel"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar','has-text-left': Language != 'fa' && Language != 'ar'}"
      >{{$t("amount").tUpper()}}</div>

      <p class="control">
        <input
          class="input"
          type="number"
          v-model="amount"
        />

        <button
          class="button is-primary is-pulled-right"
          id="submitTransferBtn"
          :class="amount<=0?'disabled':''"
          @click="requestInternalTransfer()"
        >{{$t("transfer").tUpper()}}</button>
      </p>
    </div>

    <div
      class="notification is-warning"
      v-if="needsCurrencyConversion"
    >{{$t('warning_currency_conversion_will_take_place')}}</div>

    <error-modal></error-modal>
  </div>
</template>

<script>
import { service } from '../../app'
import { mapActions, mapGetters } from 'vuex'
import api from '../../api'
import config from '../../config'
import ErrorModal from '../../components/ErrorModal'

export default {
  components: {
    ErrorModal,
  },
  data: function () {
    return {
      selected: {
        fromWallet: '',
        from: {
          external_id: '',
          currency: false,
        },
        toWallet: '',
        to: {
          external_id: '',
          currency: false,
        },
      },
      amount: '',
      currencySymbols: config.currencies,
    }
  },
  computed: {
    needsCurrencyConversion: function () {
      let f = this.selected.from.currency
      let t = this.selected.to.currency

      let currencies = ['USD', 'EUR', 'GBP']

      if (currencies.indexOf(f) === -1 || currencies.indexOf(t) === -1) {
        return false
      } else {
        return f !== t
      }
    },
    ...mapGetters({
      User: 'user/all',
      Finance: 'finance/all',
      Language: 'language/code',
      IsVerified: 'user/isVerified',
    }),
  },
  watch: {
    'selected.fromWallet'(fw) {
      if (this.selected.fromWallet === 'yes') {
        this.selected.from.external_id = ''
        this.selected.toWallet = ''
        this.selected.from.currency = this.User.wallet.currency
      }
    },
    'selected.toWallet'(tw) {
      if (this.selected.toWallet === 'yes') {
        this.selected.to.external_id = ''
        this.selected.to.currency = this.User.wallet.currency
      }
    },
    'selected.from.external_id'(taid) {
      if (this.selected.fromWallet === 'no') {
        this.selected.from.currency = this.getTACurrency(this.selected.from.external_id)
      }
    },
    'selected.to.external_id'(taid) {
      if (this.selected.toWallet === 'no') {
        this.selected.to.currency = this.getTACurrency(this.selected.to.external_id)
      }
    },
  },
  mounted() {
    if (this.Finance.deposit.selected.paymentMethod !== null) {
      this.selected.from.external_id = this.Finance.deposit.selected.paymentMethod.external_id
      // reset
      this['finance/preSelectedDepositValue'](null)
    }
    api.GetWallet()
    api.GetTradingAccounts()
  },
  methods: {
    getFromAmount(ta) {
      if (ta.equity > 0 && parseFloat(ta.balance) > parseFloat(ta.equity)) {
        return ta.equity
      }
      return ta.balance
    },
    disableSection2() {
      if (this.selected.fromWallet === 'yes' || (this.selected.fromWallet === 'no' && this.selected.from.external_id !== '')) {
        return ''
      } else {
        return 'disabled'
      }
    },
    disableSection3() {
      if (this.selected.toWallet === 'yes' || (this.selected.toWallet === 'no' && this.selected.to.external_id !== '')) {
        return ''
      } else {
        return 'disabled'
      }
    },
    disableToWallet() {
      if (this.selected.fromWallet === 'yes') {
        return 'disabled'
      } else {
        return ''
      }
    },
    getTACurrency(TAID) {
      for (let i = 0; i < this.User.TA.length; i++) {
        if (TAID === this.User.TA[i].external_id) {
          return this.User.TA[i].currency
        }
      }
      return false
    },
    requestInternalTransfer: function () {
      if (this.selected.fromWallet === 'yes' && this.amount < config.finance.minDeposit) {
        this.$toasted.error(this.$t('min_transfer_is_amount', { amount: config.finance.minDeposit }), { duration: 10000 })
        return
      }
      this['logoLoader/set'](true)

      service
        .post('/finance/internal-transfer', {
          userID: this.User.info.ID,
          amount: String(this.amount),
          fromWallet: this.selected.fromWallet === 'yes',
          toWallet: this.selected.toWallet === 'yes',
          fromTA: this.selected.from.external_id === '' ? -1 : parseInt(this.selected.from.external_id),
          toTA: this.selected.to.external_id === '' ? -1 : parseInt(this.selected.to.external_id),
        })
        .then(response => {
          if (response.data.success) {
            api.GetWallet()
            api.GetTradingAccounts()
            this.amount = ''
            this.$toasted.success(this.$t('internal_transfer_processed_successfully'))
          }
          this['logoLoader/set'](false)
        })
        .catch(error => {
          if (error.response.data.meta) {
            let meta = error.response.data.meta
            let tkey = config.API.translationKeyName
            if (meta[tkey]) {
              let trep = {}
              if (meta[tkey] === 'error_min_balance_required_is') {
                trep = {
                  TAAccountType: meta['TAAccountType'] == 'elite' ? 'Zero Commission' : meta['TAAccountType'],
                  TAID: meta['TAID'],
                  currency: meta['currency'],
                  min: meta['min'],
                }
              }
              if (meta[tkey] === 'withdrawal_unsuccessful_free_margin_taid') {
                trep = { TAID: this.selected.from.external_id }
              }
              this['errorModal/set']({ active: true, text: this.$t(meta[tkey], trep).tTitle() })
            }
          }
          this['logoLoader/set'](false)
        })
    },
    ...mapActions(['logoLoader/set', 'errorModal/set', 'finance/preSelectedDepositValue']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '~bulma/sass/utilities/mixins';
@import '../../assets/css/variables';

label.radio,
.select,
input[type='text'],
input[type='number'] {
  width: 200px;
  max-width: 480px;
  font-weight: 700;
  @include until($mobile) {
    max-width: 48%;
    font-size: 12px;
  }
}

input[type='radio'] {
  width: 25px;
  height: 25px;
  float: left;
}

.internalTransferStepSection {
  max-width: 480px;

  .stepSectionLabel {
    font-size: 25px;
    color: $secondary;
    font-weight: 900;
    margin-bottom: 5px;
  }
}

.notification {
  margin-top: 10px;
  max-width: 480px;
}

.labelText {
  height: 25px;
  line-height: 25px;
  font-weight: 900;
  float: left;
  margin-left: 5px;
  @include until($mobile) {
    font-size: 13px;
  }
}

.nextStepArrow {
  margin-top: 30px;
  margin-bottom: 30px;
  float: left;
}

.radio + .radio {
  margin-left: 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// InternalTransfer.vue?25926db8